import {AbstractModel} from './abstract.model';

export interface AbstractDictModel extends AbstractModel {
    code: string;
    name: string;
    nameEn: string;
}
